<div class="p-l">
  <h2 class="pb-s">Wählen Sie Ihre Apotheke aus</h2>
  <p>Folgende Konten stehen für Ihr Profil zur Verfügung:</p>
  <mat-radio-group class="vertical-radio-group">
    @for (idf of data['idfs']; track idf) {
      <mat-radio-button
        class="idf-selector-button"
        [value]="idf.idf"
        [checked]="data['currentIdf'] === idf.idf"
        (change)="selectedIdf = idf"
      >
        <p class="mb-xs">IDF: {{idf.idf}}</p>
        <p class="mb-xs">{{idf.name}}</p>
      </mat-radio-button>
    }
  </mat-radio-group>
  <div class="d-flex jce">
    <button (click)="closeDialog()" mat-flat-button color="primary">Anwenden</button>
  </div>
</div>
